<div
  *ngFor="let item of formHeaders"
  class="header-item"
  [class.sticky]="item.sticky"
  [style.top.px]="item.top"
  #headerElem
>
  <attribute-item  [item]="{ key: item.headerKey, value: item.headerValue}"></attribute-item>
</div>
<hr *ngIf="formHeaders?.length" class="divider">
